export const RE_DIGIT = new RegExp(/^\d+$/);